import React from 'react';
import { motion } from 'framer-motion';
export function PainSection() {
  return <section className="py-10 px-4 bg-white/50" data-id="element-313">
      <div className="max-w-3xl mx-auto space-y-6" data-id="element-314">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="text-center space-y-4" data-id="element-315">
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-navy" data-id="element-316">
            Quién es para ti{' '}
            <span className="text-terracotta text-2xl block mt-2 font-sans font-normal" data-id="element-317">
              (y por qué te está doliendo tanto)
            </span>
          </h2>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="space-y-6 text-lg text-navy/80 leading-relaxed" data-id="element-318">
          <p data-id="element-319">
            Si hoy estás cuidando a tus padres (o a uno de ellos) y sientes que
            la vida se te hizo más pequeña…{' '}
            <span className="font-semibold text-navy" data-id="element-320">no es imaginación.</span>
          </p>

          <ul className="space-y-3 pl-6 border-l-2 border-terracotta/30 my-4" data-id="element-321">
            <li className="pl-4" data-id="element-322">Tu agenda ya no te pertenece.</li>
            <li className="pl-4" data-id="element-323">Tu mente nunca se apaga.</li>
            <li className="pl-4" data-id="element-324">
              Tu cuerpo está presente, pero tú por dentro estás en "modo
              alerta".
            </li>
          </ul>

          <p data-id="element-325">
            Y aunque nadie lo diga, tú lo sabes: en muchas familias, el cuidado
            no se reparte.{' '}
            <span className="italic font-serif text-xl" data-id="element-326">Se asigna.</span>
          </p>

          <p data-id="element-327">
            Siempre cae en la misma persona.
            <br data-id="element-328" />
            La que resuelve.
            <br data-id="element-329" />
            La que no falla.
            <br data-id="element-330" />
            La que "puede".
          </p>

          <div className="bg-cream border border-navy/10 p-6 rounded-xl mt-6 shadow-sm" data-id="element-331">
            <p className="text-xl font-serif text-navy italic text-center" data-id="element-332">
              "A esa persona muchas veces se le llama, sin decirlo,{' '}
              <span className="text-terracotta font-bold not-italic" data-id="element-333">
                el hijo bastón
              </span>
              : el soporte emocional y práctico cuando el sistema familiar se
              inclina."
            </p>
          </div>

          <p className="text-lg md:text-xl font-serif italic font-bold text-navy/70 text-center mt-6" data-id="element-334">
            "La mayoría de los cuidadores no se quiebra por falta de amor. Se
            quiebra porque nadie les enseñó cómo sostener el cuidado sin
            desaparecer."
          </p>
        </motion.div>
      </div>
    </section>;
}